// extracted by mini-css-extract-plugin
export default {"dashWrapper":"Dashboard_dashWrapper__p10D7"};